<template>
  <div>
    <notifications-table-header></notifications-table-header>
    <notifications-provider></notifications-provider>
  </div>
</template>

<script>
import NotificationsTableHeader from '@/components/layout/notifications/NotificationsTableHeader'
import NotificationsProvider from '@/components/provider/NotificationsProvider'

export default {
  name: 'Notifications',

  components: {
    NotificationsTableHeader,
    NotificationsProvider,
  },
}
</script>
<style lang="scss"></style>
